import axios from 'axios'
import { interceptor } from '@/application/utils/interceptor.js'

const domain = process.env.VUE_APP_API_PATH
const messagePackagesApi = `${domain}api/v1/dashboard/packages/`
const getPaddleLinkApi = (packageId) => `${domain}api/v1/dashboard/buy-package/${packageId}/`

export const getPackages = () => interceptor(axios).get(messagePackagesApi)
export const getPaddleLink = (packageId, data) => interceptor(axios).post(getPaddleLinkApi(packageId), data)
